import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, Validators} from '@angular/forms';
import {AdminPanelState} from '../../store/reducers/admin-panel.reducer';
import {select, Store} from '@ngrx/store';
import {takeUntil} from 'rxjs/operators';
import {GetAllCompaniesAction} from '../../store/actions/admin-panel.action';
import {CompanyModel} from '../../models/company.model';
import {getAllCompanies} from '../../store/selectors/admin-panel.selector';
import {TimeZoneService} from '@core/services/time-zone.service';

@Component({
    standalone: false,
    selector: 'lib-clone-user',
  templateUrl: './clone-user.component.html',
  styleUrls: ['./clone-user.component.scss']
})
export class CloneUserComponent implements OnInit, OnDestroy {

  result: any;
  user: string;
  companies: CompanyModel[];
  cloneUserForm: any;
  cloneUserFormErrors: any;
  unSubscribe$ = new Subject<void>();

  constructor(public dialogRef: MatDialogRef<CloneUserComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private formBuilder: FormBuilder,
              private timeZoneService: TimeZoneService,
              private store: Store<AdminPanelState>) {
    this.cloneUserFormErrors = {
      companyModel: {},
      email: {}
    };
    this.result = {
      save: false,
      user: null,
      email: '',
      companyId: ''
    };
  }

  ngOnInit() {
    this.store.pipe(select(getAllCompanies), takeUntil(this.unSubscribe$)).subscribe(companies => {
      this.companies = companies;
    });
    this.store.dispatch(new GetAllCompaniesAction());

    this.cloneUserForm = this.formBuilder.group({
      companyModel: [this.data.companyId, Validators.required],
      email: [this.data.user.email, Validators.compose([
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')
      ])]
    });

    this.cloneUserForm.valueChanges.subscribe(() => {
      this.onFormValueChanged();
    });
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  onFormValueChanged() {
    for (const field in this.cloneUserFormErrors) {
      if (!this.cloneUserFormErrors.hasOwnProperty(field)) {
        continue;
      }

      this.cloneUserFormErrors[field] = {};
      const control = this.cloneUserForm.get(field);

      if (control && control.dirty && !control.valid) {
        this.cloneUserFormErrors[field] = control.errors;
      }
    }
  }

  onSave() {
    if (this.cloneUserForm.valid) {
      this.result.save = true;
      this.result.user = this.data.user;
      this.result.email = this.cloneUserForm.value.email;
      this.result.companyId = this.cloneUserForm.value.companyModel;
    }
  }

}
